'use strict';
import gsap from 'gsap';


class Tab {
	constructor(el) {
		this.$tab = $(el);
		this.$tabList = this.$tab.find('.ui-tab__list');
		this.$tabBody = this.$tab.find('.ui-tab__body');
		this.$tabContent = this.$tabBody.find('.ui-tab__content');
		this.build();
	}

	build(){
		this.$tabList.find('li').on('click', (e)=>{
			let
				$li = $(e.currentTarget),
				index = $li.index();

			if( $li.hasClass('is-current') ) return false;
			this.change(index);
			return false;
		});
	}

	change(index){
		this.$tabList.find('li').eq(index).addClass('is-current')
			.siblings().removeClass('is-current');

		this.$tabContent.eq(index).addClass('is-current')
			.siblings().removeClass('is-current');
			//fadein
			let
			tl = gsap.timeline();
			tl
				.set(this.$tabContent, {opacity:0})
				.delay(0.1)
				.to(this.$tabContent.eq(index) , {duration:1.4, opacity:1, ease:app.Config.easing})
	}




}

export default Tab;
